import React from 'react';
import styled from 'styled-components';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../common/responsive';
import WidthContainer from '../../../WidthContainer';
import {
  BodyLarge,
  Heading1Text,
  TitleLarge,
  TitleMedium,
} from '../../../Texts';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 90px;
  padding-bottom: 90px;
  gap: 30px;
`;

const ColorizedSpan = styled.span`
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.text.title} 0%,
    ${({ theme }) => theme.special.purple} 30%,
    ${({ theme }) => theme.primary.primary} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
  width: 100%;
  @media ${PHONE_MEDIA_QUERY} {
    grid-template-columns: repeat(auto-fill, minmax(90%, 1fr));
  }
`;

// Grid item (card) styling
const GridItem = styled.div`
  width: 100%;
  height: 200px;
  background-color: ${({ theme }) => theme.background.primary};
  border: 1px solid ${({ theme }) => theme.border.primary};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 10px;
  padding: 60px 20px;
  transition: transform 0.3s ease;
  cursor: pointer;
  @media (hover: hover) {
    &:hover {
      transform: translateY(-5px);
    }
  }
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
  }
`;

const BackgroundColor = styled.div`
  background: ${({ theme }) => theme.background.gradient.primary};
`;

const StyledTitleLarge = styled(TitleLarge)`
  font-weight: 600;
`;

const WhyBecomeAReferral = () => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  return (
    <BackgroundColor>
      <WidthContainer>
        <Container>
          <Heading1Text style={isMobile ? { textAlign: 'center' } : {}}>
            Why become a <ColorizedSpan>Referral Partner?</ColorizedSpan>
          </Heading1Text>
          <GridContainer>
            <GridItem>
              <StyledTitleLarge>Referral Partner?</StyledTitleLarge>
              <BodyLarge>
                Get 50% of platform fees from every project you refer to.
              </BodyLarge>
            </GridItem>
            <GridItem>
              <StyledTitleLarge>Sticky projects</StyledTitleLarge>
              <BodyLarge>90% of tokens listed keep selling weekly.</BodyLarge>
            </GridItem>
            <GridItem>
              <StyledTitleLarge>Easy onboarding</StyledTitleLarge>
              <BodyLarge>Projects go live within 24 hours of call.</BodyLarge>
            </GridItem>
            <GridItem>
              <StyledTitleLarge>Promo materials</StyledTitleLarge>
              <BodyLarge>
                Access to pitch decks, demos, and case studies.
              </BodyLarge>
            </GridItem>
            <GridItem>
              <StyledTitleLarge>No cap, no limit</StyledTitleLarge>
              <BodyLarge>Refer as many projects as you like.</BodyLarge>
            </GridItem>
            <GridItem>
              <StyledTitleLarge>12-month commissions</StyledTitleLarge>
              <BodyLarge>
                You keep earning from their activity for a full year.
              </BodyLarge>
            </GridItem>
          </GridContainer>
        </Container>
      </WidthContainer>
    </BackgroundColor>
  );
};

export default WhyBecomeAReferral;
